import { defaultVendor, vendors } from '../config/vendor';

let resolvedVendor;

/**
 * Calculate vendor name based on current window location
 * @return {String}
 */
export default function useVendor(): string {
    if (!resolvedVendor) {
        const host = window.location.hostname.replace(/(.-dtap|www|beta)\./, '');
        resolvedVendor = vendors[host] ? host : defaultVendor;
    }

    return resolvedVendor;
}
